<template>
    <div>
        <div class="d-flex justify-content-between">
            <h1 class="page-header">{{ $t('academicResult.pageTitle') }}</h1>
            <ts-breadcrumb :items="[
                { text: $t('toHomePage'), href: '/' },
                {
                    text: $t('academicResult.pageTitle'),
                    active: true
                }
            ]" />
        </div>
        <ts-card>
            <ts-card-wrapper>
                <div class="row">
                    <div class="col-md-3">
                        <ts-loading-banner :loading="loading">
                            <form>
                                <fieldset>
                                    <legend>{{ $t('academicResult.filterCriteria') }}</legend>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('academicResult.branchName')
                                            }}</label>
                                            <a-select style="width: 100%" v-model.number="model.branch_id"
                                                :options="branches"></a-select>
                                            <div class="validate" v-if="errors.has('branch_id')">
                                                {{ errors.first('branch_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('academicResult.acYear')
                                            }}</label>
                                            <a-select style="width: 100%" v-model.number="model.ac_year_id"
                                                :options="ac_year_list" @change="onAcYearChange"></a-select>
                                            <div class="validate" v-if="errors.has('ac_year_id')">
                                                {{ errors.first('ac_year_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('academicResult.subProgram')
                                                }}</label>
                                            <a-select style="width: 100%" v-model.number="model.acps_id"
                                                :options="sub_programs" :show-search="true" :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    " :disabled="!model.ac_year_id" @change="onSubChange"></a-select>
                                            <div class="validate" v-if="errors.has('acps_id')">
                                                {{ errors.first('acps_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{ $t('academicResult.Degree') }}</label>
                                            <a-select style="width: 100%" v-model="model.level_id" mode="multiple"
                                                :options="levels" :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    "></a-select>
                                            <div class="validate" v-if="errors.has('level_id')">
                                                {{ errors.first('level_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label>{{ $t('academicResult.class') }}</label>
                                            <a-select style="width: 100%" v-model="model.class_id"
                                                :options="class_options" :show-search="true" :placeholder="$t('all')"
                                                :limit="1" :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    " @change="onClassChange" mode="multiple"></a-select>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label>{{ $t('academicReport.student') }}</label>
                                            <a-select style="width: 100%" v-model="model.student_id"
                                                :options="student_lists" :show-search="true" :loading="fetching_student"
                                                :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    " mode="multiple"></a-select>
                                            <div class="validate" v-if="errors.has('student_id')">
                                                {{ errors.first('student_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label>{{ $t('academicResult.batch') }}</label>
                                            <input type="number" class="form-control"
                                                v-model.number="model.promotion" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 text-center">
                                            <ts-button class="btn-block" color="primary" @click.prevent="preview"
                                                :waiting="waiting">{{ $t('preview') }}</ts-button>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                        </ts-loading-banner>
                    </div>
                    <div class="col-md-9">
                        <ts-preview-pdf v-model="waiting" :src="src" />
                    </div>
                </div>
            </ts-card-wrapper>
        </ts-card>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import { Errors } from 'form-backend-validation'

export default {
    name: 'academicReport',
    data() {
        return {
            loading: false,
            fetching_student: false,
            errors: new Errors(),
            waiting: false,
            src: '',
            branches: [],
            ac_year_list: [],
            sub_programs: [],
            student_lists: [],
            levels: [],
            class_options: [],
            model: {
                branch_id: null,
                ac_year_id: null,
                acps_id: null,
                class_id: [],
                level_id: [],
                student_id: [],
                promotion: null
            }
        }
    },
    created() {
        this.fetchData()
    },
    methods: {
        ...mapActions('reportAcademic', [
            'getBranch',
            'getYear',
            'getSubProgram',
            'getLevel',
            'getFormViewModel',
            'academicResult',
            'getClass'
        ]),
        async fetchData() {
            this.loading = true
            await this.getBranch().then(response => {
                this.branches = response.data.map(el => ({
                    value: el.branch_id,
                    label: el.branch_name_en
                }))
                this.model.branch_id = this.$store.state.authUser.default_branch_id
            })
            await this.getYear()
                .then(response => {
                    this.ac_year_list = response.data.map(el => ({
                        value: el.ac_year_id,
                        label: el.ac_year
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
            await this.getSubProgram().then(response => {
                this.sub_programs = response.data.map(el => ({
                    value: el.acps_id,
                    label: el.acps_name_foreign
                }))
            })

        },
        async onSubChange(acps_id) {
            this.model.level_id = []
            await this.getLevel({
                filter: {
                    acps_id: acps_id
                }
            })
                .then(response => {
                    this.levels = response.data.map(el => ({
                        value: el.level_id,
                        label: el.level_name_foreign
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
            await this.getClass({
                filter: {
                    ac_year_id: this.model.ac_year_id,
                    acps_id: this.model.acps_id
                }
            })
                .then(response => {
                    this.class_options = response.data.map(el => ({
                        value: el.class_id,
                        label: el.class_name
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        async fetchStudents() {
            if (!this.model.ac_year_id || !this.model.acps_id) {
                this.student_lists = []
                return
            }
            this.fetching_student = true
            await this.getFormViewModel({
                fnName: 'studentProfile',
                ac_year_id: this.model.ac_year_id,
                acps_id: this.model.acps_id
            })
                .then(response => {
                    this.student_lists = response.data.studentProfile.map(el => ({
                        value: el.student_id,
                        label: el.full_name_en
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.fetching_student = false
                })
        },
        onAcYearChange() {
            this.model.acps_id = null
            this.model.level_id = []
            this.model.student_id = []

        },
        onClassChange() {
            this.fetchStudents()
        },
        preview() {
            this.waiting = true
            this.src = ''
            this.errors = new Errors()

            const payload = {
                ...this.model,
                student_id: this.model.student_id,
                level_id: this.model.level_id,
                ac_year_id: this.model.ac_year_id
            }
            this.academicResult(payload)
                .then(response => {
                    this.src = response.url
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => {
                    this.waiting = false
                })
        },
    }
}
</script>